module.exports = __webpack_public_path__ + "img/list_4_zh.ac2f6283.png";